import type { TFunction } from 'i18next';
import enServices from '../locales/en/services.json';
import koServices from '../locales/ko/services.json';
import { getStoredPortalLocale } from './portalLocaleEvents';
import type { PortalLocale } from './constants';

/** React 없이 micro-FE·auth hook에서 사용 */
export function resolveServiceNameForLocale(
  folder: string,
  fallbackName: string,
  locale?: PortalLocale,
): string {
  const loc = locale ?? getStoredPortalLocale();
  const catalog = loc === 'en' ? enServices : koServices;
  const block = (catalog as Record<string, { name?: string }>)[folder];
  return block?.name ?? fallbackName;
}

export function resolveServiceDescriptionForLocale(
  folder: string,
  fallbackDescription: string,
  locale?: PortalLocale,
): string {
  const loc = locale ?? getStoredPortalLocale();
  const catalog = loc === 'en' ? enServices : koServices;
  const block = (catalog as Record<string, { description?: string }>)[folder];
  return block?.description ?? fallbackDescription;
}
export function resolveServiceName(
  folder: string,
  fallbackName: string,
  t: TFunction,
): string {
  return t(`${folder}.name`, { defaultValue: fallbackName });
}

/** 카드 description — en 없으면 API description 유지 */
export function resolveServiceDescription(
  folder: string,
  fallbackDescription: string,
  t: TFunction,
): string {
  return t(`${folder}.description`, { defaultValue: fallbackDescription });
}
